<template>
  <DropdownContainer
    ref="dropdownContainerInsuranceSemler"
    :modal-size="'large'"
  >
    <div class="insurance-semler__contact-form" id="InsuranceSemlerContactForm">
      <div class="insurance-semler__contact-form-title">Udfyld ansøgning</div>
      <div class="insurance-semler__contact-form-intro-text">
        <p>
          Du er ved at ansøge om en forsikring hos:
          <b>{{ insuranceCompanyName }}</b>
        </p>
        <br />
        <p>
          Din valgte alder: {{ selectedAge }}<br />
          Bilens pris: {{ thousandSeparator(adPrice) }} {{ postfix }}<br />
          Forsikringspræmie: {{ thousandSeparator(insurancePrice) }} {{ postfix
          }}<br />
          Selvrisiko: {{ thousandSeparator(coinsurancePrice) }} {{ postfix
          }}<br />
        </p>
      </div>
      <div class="insurance-semler__input-container">
        <p class="error my-1" v-if="userNameErrorMessage">
          <span>{{ userNameErrorMessage }}</span>
          <span class="error__attention"></span>
        </p>
        <div class="input-container">
          <input
            title="Name"
            type="text"
            id="input_contact-form_name"
            placeholder="Skriv dit navn her"
            class="error--input insurance-semler__input form-control"
            v-model="userName"
          />
          <label
            for="input_contact-form_name"
            class="insurance-semler__input-label control-label"
            >Navn</label
          >
        </div>
      </div>
      <div class="insurance-semler__input-container">
        <p class="error my-1" v-if="userEmailErrorMessage">
          <span>{{ userEmailErrorMessage }}</span>
          <span class="error__attention"></span>
        </p>
        <div class="input-container">
          <input
            title="Email"
            type="text"
            id="input_contact-form_email"
            placeholder="Skriv din email her"
            class="error--input insurance-semler__input form-control"
            v-model="userEmail"
          />
          <label
            for="input_contact-form_email"
            class="insurance-semler__input-label control-label"
            >Email</label
          >
        </div>
      </div>
      <div class="insurance-semler__input-container">
        <p class="error my-1" v-if="userPhoneErrorMessage">
          <span>{{ userPhoneErrorMessage }}</span>
          <span class="error__attention"></span>
        </p>
        <div class="input-container">
          <input
            title="Phone"
            type="text"
            id="input_contact-form_phone"
            placeholder="Skriv dit telefonnummer her"
            class="error--input insurance-semler__input form-control"
            v-model="userPhone"
          />
          <label
            for="input_contact-form_phone"
            class="insurance-semler__input-label control-label"
            >Telefonnummer</label
          >
        </div>
      </div>
      <div class="insurance-semler__recaptcha">
        <p class="error my-1" v-if="recaptchaErrorMessage">
          <span>{{ recaptchaErrorMessage }}</span>
          <span class="error__attention"></span>
        </p>
        <div data-callback="recaptchaCallback" ref="recaptcha"></div>
      </div>
    </div>
    <div>
      <button
        class="button button--highlight insurance-semler__submit-button"
        :disabled="inProgress"
        @click="sendForm()"
      >
        <span>Ansøg nu</span>
        <ButtonSpinner v-if="inProgress" />
      </button>
    </div>
  </DropdownContainer>
</template>

<script>
import { app } from '@/main'
import { nextTick } from 'vue'

import ButtonSpinner from '@components/Shared/ButtonSpinner/ButtonSpinner.vue'
import DropdownContainer from '@shared/DropdownContainer/DropdownContainer.vue'
import { LogWidgetSentApplicationInsuranceSemler } from '@/events'
import { thousandSeparator } from '@/functions'

export default {
  name: 'InsuranceSemlerContactForm',
  components: {
    DropdownContainer,
    ButtonSpinner,
  },
  props: {
    adId: { default: null, type: Number },
    userNameProp: { default: '', type: String },
    userEmailProp: { default: '', type: String },
    userPhoneProp: { default: '', type: String },
    insurancePrice: { default: null, type: Number },
    coinsurancePrice: { default: null, type: Number },
    adPrice: { default: null, type: Number },
    recaptchaSitekey: { default: '', type: String },
    insuranceCompanyName: { default: '', type: String },
    selectedAge: { default: '', type: String },
  },
  data: function () {
    return {
      userName: '',
      userEmail: '',
      userPhone: '',
      errorHappened: false,
      userNameErrorMessage: '',
      userEmailErrorMessage: '',
      userPhoneErrorMessage: '',
      recaptchaErrorMessage: '',
      recaptchaRendered: false,
      recaptchaIndex: undefined,
      inProgress: false,
      postfix: 'kr.',
    }
  },
  methods: {
    init() {
      this.userName = this.userNameProp
      this.userEmail = this.userEmailProp
      this.userPhone = this.userPhoneProp
    },
    closeForm() {
      this.clearAll()
      this.$refs.dropdownContainerInsuranceSemler.close()
    },
    openForm() {
      this.$refs.dropdownContainerInsuranceSemler.open()

      this.$nextTick(() => {
        if (window.grecaptcha !== undefined && !this.recaptchaRendered) {
          this.recaptchaIndex = window.grecaptcha.render(this.$refs.recaptcha, {
            sitekey: this.recaptchaSitekey,
          })
          this.recaptchaRendered = true
        }
      })
    },
    sendForm() {
      this.inProgress = true
      this.formValidation()

      if (this.errorHappened) {
        this.inProgress = false
        window.grecaptcha.reset(this.recaptchaIndex)
        return
      }

      let url = '/api/Semler/SendMessageInsurance'

      const owner = this

      app.axios
        .post(window.location.origin + url, {
          userName: this.userName,
          userEmail: this.userEmail,
          userPhone: this.userPhone,
          age: this.selectedAge,
          adId: this.adId,
          insurancePrice: this.insurancePrice,
          coinsurancePrice: this.coinsurancePrice,
          recaptchaResponse: window.grecaptcha.getResponse(this.recaptchaIndex),
        })
        .then(resp => {
          if (
            resp.data &&
            resp.data.errorCollection &&
            resp.data.errorCollection.length == 0
          ) {
            let successMessage = 'Din ansøgning er blevet sendt'
            nextTick(() => {
              app.toast.success(successMessage)
            })
            LogWidgetSentApplicationInsuranceSemler()
            owner.closeForm()
          } else if (
            resp.data.errorCollection &&
            resp.data.errorCollection.length > 0
          ) {
            app.toast.error(resp.data.errorCollection[0].errorMessage)
          }
          this.inProgress = false
          window.grecaptcha.reset(this.recaptchaIndex)
        })
    },
    thousandSeparator(value) {
      return thousandSeparator(value)
    },
    clearErrorMessages() {
      this.errorHappened = false
      this.userNameErrorMessage = ''
      this.userEmailErrorMessage = ''
      this.userPhoneErrorMessage = ''
      this.recaptchaErrorMessage = ''
      this.recaptchaRendered = false
    },
    clearAll() {
      this.clearErrorMessages()
      this.userName = ''
      this.userEmail = ''
      this.userPhone = ''
      window.grecaptcha.reset(this.recaptchaIndex)
    },
    recaptchaCallback() {
      this.recaptchaErrorMessage = ''
    },
    isNullOrEmpty(str) {
      if (str === null) return true
      if (typeof str === 'undefined') return true
      if (str === '') return true
      if (str.trim() === '') return true
      return false
    },
    formValidation() {
      this.clearErrorMessages()

      if (this.isNullOrEmpty(this.userName)) {
        this.userNameErrorMessage = 'Du skal udfylde dit navn'
        this.errorHappened = true
      }

      if (
        this.isNullOrEmpty(this.userEmail) &&
        this.isNullOrEmpty(this.userPhone)
      ) {
        this.userEmailErrorMessage =
          'Angiv enten emailadresse eller telefonnumer'
        this.errorHappened = true
      }
      if (window.grecaptcha.getResponse(this.recaptchaIndex) === '') {
        this.recaptchaErrorMessage = 'Du skal bevise at du ikke er en robot'
        this.errorHappened = true
      }
    },
  },
  created() {
    window.recaptchaCallback = this.recaptchaCallback
    this.init()
  },
}
</script>

<style lang="scss">
@import 'InsuranceSemler.scss';
</style>
